import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import React from 'react';

const RECAPTCHA_KEY =
  import.meta.env.VITE_RECAPTCHA_KEY || '6LfcXlQrAAAAAHCt1Sl0QIAt83v9ygJ586A7m9OV';

export const ReCaptchaProvider = ({ children }) => {
  return <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>{children}</GoogleReCaptchaProvider>;
};
